import clsx from 'clsx';
import * as React from 'react';
import { match } from 'ts-pattern';
import { colors } from '@ovpn-ui/styles';
import { polymorphicAsProp } from '../types';
import * as Styled from './Banner.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Banner = /*#__PURE__*/React.forwardRef(function Banner({
  variant = 'info',
  as = 'div',
  persistent: deprecatedPersistentProp,
  icon,
  title,
  footer,
  onClose,
  className,
  children,
  ...props
}, ref) {
  if (deprecatedPersistentProp !== undefined) {
    console.warn('`persistent` prop is no longer supported. Please, use `onClick` instead. Read more: https://ovpn-ui-shared-next.devopenvpn.in/?path=/docs/core-banner-overview--page#closable');
  }
  const iconColor = match(variant).with('success', () => colors.successBaseActive).with('attention', () => colors.attentionBaseActive).with('warning', () => colors.warningBaseActive).otherwise(() => colors.neutralTextBody);
  const StyledBanner = match(variant).with('success', () => Styled.SuccessBanner).with('attention', () => Styled.AttentionBanner).with('warning', () => Styled.WarningBanner).otherwise(() => Styled.InfoBanner);
  return /*#__PURE__*/_jsxs(StyledBanner, {
    ...polymorphicAsProp(as),
    ref: ref,
    role: "banner",
    className: clsx('ovpn-banner', className),
    ...props,
    children: [icon && /*#__PURE__*/React.cloneElement(icon, {
      color: iconColor,
      strokeWidth: 2,
      className: 'ovpn-banner-icon'
    }), /*#__PURE__*/_jsxs(Styled.Container, {
      className: "ovpn-banner-container",
      children: [/*#__PURE__*/_jsx(Styled.Header, {
        className: "ovpn-banner-header",
        children: title
      }), children && /*#__PURE__*/_jsx(Styled.Content, {
        className: "ovpn-banner-content",
        children: children
      }), footer && /*#__PURE__*/_jsx(Styled.Footer, {
        className: "ovpn-banner-footer",
        children: footer
      })]
    }), (deprecatedPersistentProp || onClose) && /*#__PURE__*/_jsx(Styled.CloseIcon, {
      strokeWidth: "2",
      onClick: onClose,
      className: "ovpn-banner-close-icon"
    })]
  });
});
export default Banner;